import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Avatar, AvatarFallback } from './ui/avatar';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Omar MD',
      location: 'Local Guide',
      text: 'Alhan is timely and professional. We had a cobra in our basement at 11:30pm. We called him and he showed up in 20 mins as discussed. Caught the snake in a flash and also answered all our questions RE snake behaviour - all at a reasonable price.',
      rating: 5,
      initials: 'OM',
    },
    {
      name: 'Lovely Grace',
      location: 'Bangalore',
      text: 'Snake catcher Alhan was so responsive when I called him. After seeing the photos, he immediately responded by telling that he would come and visit the spot directly not just to catch the snake but because he was concerned about my kids safety. He handled the situation really well in a professional manner. The overall experience was very educative for all of us.',
      rating: 5,
      initials: 'LG',
    },
    {
      name: 'Gayathri Sagili',
      location: 'Bangalore',
      text: 'Today I had a snake at utility area and called Alhan, he is very professional and he taken kobra safely within a minute and he reached to the spot also within 5 minutes. He dealt very smoothly. Thank you so much!',
      rating: 5,
      initials: 'GS',
    },
    {
      name: 'Harish Anu',
      location: 'Bangalore',
      text: 'Alhan is highly professional, had a very quick and responsible response. Caught hold of the snake (Cobra) and gave a few necessary tips.',
      rating: 5,
      initials: 'HA',
    },
    {
      name: 'Aishwarya Kumar J',
      location: 'Local Guide',
      text: 'The person arrived within 2 minutes of our call and handled the situation with great patience.',
      rating: 5,
      initials: 'AK',
    },
    {
      name: 'Charan S',
      location: 'Bangalore',
      text: 'Responded and arrived quickly. Highly recommend him.',
      rating: 5,
      initials: 'CS',
    },
  ];

  return (
    <section 
      id="testimonials"
      className="py-20 md:py-32 bg-[#F5F3ED]"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Section Header */}
        <div className="text-center mb-16">
          <Badge variant="outline" className="mb-4 text-[#2A4B35] border-[#2A4B35]">
            Google Reviews
          </Badge>
          <h2 
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1A1D1A] mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
            data-testid="testimonials-heading"
          >
            Trusted Snake Catcher in Bangalore
          </h2>
          <p className="text-[#4A4D4A] text-lg max-w-2xl mx-auto">
            Real reviews from families and communities who called our <strong>snake rescue number</strong>
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <Card 
              key={index}
              className="bg-white border-[#D8D4C7] rounded-2xl hover:shadow-lg transition-shadow duration-300"
              data-testid={`testimonial-card-${index + 1}`}
            >
              <CardContent className="p-6">
                {/* Quote Icon */}
                <Quote className="w-8 h-8 text-[#2A4B35]/20 mb-4" />
                
                {/* Rating */}
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-[#F59E0B] text-[#F59E0B]" />
                  ))}
                </div>
                
                {/* Text */}
                <p className="text-[#4A4D4A] mb-6 leading-relaxed">
                  "{testimonial.text}"
                </p>
                
                {/* Author */}
                <div className="flex items-center gap-3">
                  <Avatar className="w-10 h-10 bg-[#2A4B35] text-white">
                    <AvatarFallback className="bg-[#2A4B35] text-white text-sm font-semibold">
                      {testimonial.initials}
                    </AvatarFallback>
                  </Avatar>
                  <div>
                    <p className="font-semibold text-[#1A1D1A]" style={{ fontFamily: 'Outfit, sans-serif' }}>
                      {testimonial.name}
                    </p>
                    <p className="text-sm text-[#4A4D4A]">{testimonial.location}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
